import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import conexIcon from '@/assets/conex-icon.png'
import farmgridLogo from '@/assets/farmgrid-logomark.png'

// @ts-ignore - Route type generation issue in Jest
export const Route = createFileRoute('/api-docs/')({
  staticData: {
    title: 'API Documentation',
    isSecured: true,
  },
  component: ApiDocsIndexPage,
})

const API_SPECS = [
  {
    id: 'conex',
    name: 'ConEx API',
    description:
      'ConEx API Gateway — auth, users and invitations, organizations and contracts, devices and live devices, sensing networks, resource management, and platform configs.',
    href: '/api-docs/conex',
    logo: conexIcon,
    version: '0.0.1',
    available: true,
  },
  {
    id: 'farmgrid',
    name: 'FarmGrid API',
    description:
      'FarmGrid API Server — vault farm, field and season profiles with crop insights, landing-zone sensor readings and drafts, and the CropView feeder.',
    href: '/api-docs/farmgrid',
    logo: farmgridLogo,
    version: '1.0.4',
    available: true,
  },
] as const

function ApiDocsIndexPage() {
  return (
    <div className="max-w-2xl mx-auto py-12 px-6">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-foreground">API Documentation</h1>
        <p className="text-sm text-muted-foreground mt-1.5">
          Interactive reference documentation for all ConEx platform APIs.
        </p>
      </div>

      <div className="grid gap-3">
        {API_SPECS.map((spec) => {
          return (
            <Card
              key={spec.id}
              className="flex items-start gap-4 p-5 hover:border-primary/40 transition-colors"
            >
              <div className="rounded-md bg-muted p-2.5 shrink-0 mt-0.5">
                <img src={spec.logo} alt="" className="size-5 object-contain" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-semibold text-sm text-foreground">{spec.name}</span>
                  <Badge variant="secondary" className="text-xs font-mono">
                    v{spec.version}
                  </Badge>
                  {!spec.available && (
                    <Badge variant="outline" className="text-xs">
                      Coming soon
                    </Badge>
                  )}
                </div>
                <p className="text-xs text-muted-foreground leading-relaxed">{spec.description}</p>
              </div>
              <Button asChild variant="ghost" size="sm" className="shrink-0 self-center gap-1.5">
                <Link to={spec.href}>
                  View docs
                  <ArrowRight className="size-3.5" />
                </Link>
              </Button>
            </Card>
          )
        })}
      </div>
    </div>
  )
}
